<template>
  <div class="contact-page">
    <!-- Hero Section -->
    <div class="hero-section">
        <div class="container">
            <h1 class="page-title">ХОЛБОО БАРИХ</h1>
            <p class="page-subtitle">
                Газар Зохион Байгуулалт, Геодези, Зураг Зүйн Ерөнхий Газар
            </p>
        </div>
    </div>
    
    <div style="max-width: 1200px; margin: 0 auto;">
        

        <!-- Contact Content -->
        <div class="contact-content">
        <div class="container">
            <div class="contact-grid">
            <!-- Contact Information -->
            <div class="contact-info">
                <div class="info-card">
                <div class="info-header">
                    <i class="fas fa-map-marker-alt"></i>
                    <h3>Хаяг</h3>
                </div>
                <div class="info-content">
                    <p>Засгийн газрын талбай, 4-р хороо,</p>
                    <p>Чингэлтэй дүүрэг, Улаанбаатар хот</p>
                    <p><strong>Шуудангийн хаяг:</strong> 15170</p>
                </div>
                </div>

                <div class="info-card">
                <div class="info-header">
                    <i class="fas fa-phone"></i>
                    <h3>Утас</h3>
                </div>
                <div class="info-content">
                    <p><a href="tel:18000101">1800 0101</a></p>
                    <p><a href="tel:51260203">(51) 260203</a></p>
                </div>
                </div>

                <div class="info-card">
                <div class="info-header">
                    <i class="fas fa-envelope"></i>
                    <h3>И-мэйл</h3>
                </div>
                <div class="info-content">
                    <p><a href="mailto:info@gazar.gov.mn">info@gazar.gov.mn</a></p>
                </div>
                </div>

                <div class="info-card">
                <div class="info-header">
                    <i class="fas fa-clock"></i>
                    <h3>Ажлын цаг</h3>
                </div>
                <div class="info-content">
                    <p><strong>Даваа - Баасан:</strong> 09:00 - 18:00</p>
                    <p><strong>Бямба, Ням:</strong> Амралтын өдөр</p>
                </div>
                </div>
            </div>

            <!-- Google Maps -->
            <div class="map-container">
                <div class="map-wrapper">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2673.1234567890123!2d106.9173!3d47.9077!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5d969237a7b8a7b9%3A0x123456789abcdef!2sGovernment%20Palace%2C%20Ulaanbaatar%2C%20Mongolia!5e0!3m2!1sen!2smn!4v1234567890123!5m2!1sen!2smn"
                    width="100%"
                    height="400"
                    style="border:0;"
                    allowfullscreen=""
                    loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade"
                >
                </iframe>
                </div>
                <p class="map-caption">Засгийн газрын талбай, Улаанбаатар хот</p>
            </div>
            </div>

            <!-- Contact Form -->
            <div class="contact-form-section">
            <h2>Санал хүсэлт илгээх</h2>
            <form class="contact-form" @submit.prevent="submitForm">
                <div class="form-row">
                <div class="form-group">
                    <label for="name">Нэр <span class="required">*</span></label>
                    <input
                    type="text"
                    id="name"
                    v-model="form.name"
                    required
                    placeholder="Таны нэрийг оруулна уу"
                    />
                </div>
                <div class="form-group">
                    <label for="email">
                    И-мэйл <span class="required">*</span>
                    </label>
                    <input
                    type="email"
                    id="email"
                    v-model="form.email"
                    required
                    placeholder="your@email.com"
                    />
                </div>
                </div>
                <div class="form-row">
                <div class="form-group">
                    <label for="phone">Утасны дугаар</label>
                    <input
                    type="tel"
                    id="phone"
                    v-model="form.phone"
                    placeholder="99123456"
                    />
                </div>
                <div class="form-group">
                    <label for="subject">
                    Гарчиг <span class="required">*</span>
                    </label>
                    <input
                    type="text"
                    id="subject"
                    v-model="form.subject"
                    required
                    placeholder="Санал хүсэлтийн гарчиг"
                    />
                </div>
                </div>
                <div class="form-group">
                <label for="message">
                    Мессеж <span class="required">*</span>
                </label>
                <textarea
                    id="message"
                    v-model="form.message"
                    required
                    rows="5"
                    placeholder="Таны санал хүсэлтийг дэлгэрэнгүй бичнэ үү..."
                ></textarea>
                </div>
                <button type="submit" class="submit-btn" :disabled="submitting">
                <i class="fas fa-paper-plane" v-if="!submitting"></i>
                <i class="fas fa-spinner fa-spin" v-else></i>
                {{ submitting ? "Илгээж байна..." : "Илгээх" }}
                </button>
            </form>
            </div>
        </div>
        </div>
    </div>
  </div>
</template>

<script>
import { request } from "@/api/all";

export default {
  name: "ContactPage",
  data() {
    return {
      form: {
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: ""
      },
      submitting: false
    }
  },
  methods: {
    async submitForm() {
      this.submitting = true;

      try {
        // Prepare data for API (combine subject and message into info field)
        const feedbackData = {
          name: this.form.name,
          mail: this.form.email,
          mobile: this.form.phone,
          info: `${this.form.subject}\n\n${this.form.message}`
        };

        // Submit to API
        const result = await request({
          api: { method: "POST", url: "User/PostFeedback" },
          data: feedbackData,
          store: this.$store,
        });

        if (result !== false) {
          // Reset form on success
          this.form = {
            name: "",
            email: "",
            phone: "",
            subject: "",
            message: ""
          };

          alert("Таны санал хүсэлт амжилттай илгээгдлээ!");
        } else {
          alert("Алдаа гарлаа. Дахин оролдоно уу.");
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        alert("Алдаа гарлаа. Дахин оролдоно уу.");
      } finally {
        this.submitting = false;
      }
    }
  }
}
</script>

<style scoped>
.contact-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.hero-section {
  background: 
    linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),
    url('https://res.gosmart.mn/apps/egazar/cover.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  filter: grayscale(100%);
  color: white;
  padding: 80px 0 60px;
  text-align: center;
  position: relative;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.page-title {
  color: white;
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 20px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.page-subtitle {
  color: white;
  font-size: 1.2rem;
  opacity: 0.9;
  max-width: 400px;
  margin: 0 auto;
  text-transform: uppercase;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.contact-content {
  padding: 60px 0;
}

.contact-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  margin-bottom: 60px;
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.info-card {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.info-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.info-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
}

.info-header i {
  font-size: 1.5rem;
  color: #667eea;
  width: 24px;
}

.info-header h3 {
  font-size: 1.3rem;
  font-weight: 600;
  margin: 0;
  color: #2d3748;
}

.info-content p {
  margin: 8px 0;
  color: #4a5568;
  line-height: 1.6;
}

.info-content a {
  color: #667eea;
  text-decoration: none;
  transition: color 0.3s ease;
}

.info-content a:hover {
  color: #5a67d8;
  text-decoration: underline;
}

.map-container {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.map-wrapper {
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 16px;
}

.map-caption {
  text-align: center;
  color: #666;
  font-style: italic;
  margin: 0;
}

.contact-form-section {
  background: white;
  border-radius: 12px;
  padding: 40px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.contact-form-section h2 {
  font-size: 2rem;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 32px;
  text-align: center;
}

.contact-form {
  max-width: 800px;
  margin: 0 auto;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  margin-bottom: 24px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 8px;
}

.required {
  color: #e53e3e;
}

.form-group input,
.form-group textarea {
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.3s ease;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #667eea;
}

.submit-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 16px 32px;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 32px auto 0;
}

.submit-btn:hover:not(:disabled) {
  transform: translateY(-2px);
}

.submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* Responsive Design */
@media (max-width: 768px) {
  .page-title {
    font-size: 2.2rem;
  }

  .contact-grid {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .form-row {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .contact-form-section {
    padding: 24px;
  }

  .container {
    padding: 0 16px;
  }
}

@media (max-width: 480px) {
  .hero-section {
    padding: 60px 0 40px;
  }

  .page-title {
    font-size: 1.8rem;
  }

  .page-subtitle {
    font-size: 1rem;
  }

  .contact-content {
    padding: 40px 0;
  }

  .info-card,
  .map-container,
  .contact-form-section {
    padding: 20px;
  }
}
</style>
